import { createActionConst } from '../../../utils/action.utils';

const KPI_ROW_SCOREBOARD_NAMESPACE = 'KPI_ROW_SCOREBOARD';

export const STORE_KPI_ROW_SCOREBOARD = createActionConst(KPI_ROW_SCOREBOARD_NAMESPACE, 'STORE_KPI_ROW_SCOREBOARD');
export const CLEAR_KPI_ROW_SCOREBOARD = createActionConst(KPI_ROW_SCOREBOARD_NAMESPACE, 'CLEAR_KPI_ROW_SCOREBOARD');
